import React from 'react';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from 'lucide-react';
import { clinicInfo } from '../data/mock';
import { Card, CardContent } from './ui/card';

const Contact = () => {
  const handleWhatsApp = () => {
    window.open(`https://wa.me/${clinicInfo.whatsapp}`, '_blank');
  };

  return (
    <section id="contact" className="py-20 px-4 bg-gradient-to-b from-white to-purple-50">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Entre em <span className="text-purple-600">Contato</span>
          </h2>
          <div className="w-24 h-1 bg-purple-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            Estamos prontos para atender você e seu pet
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Contact Information */}
          <div className="space-y-6">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">Informações de Contato</h3>
            
            <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-purple-100 rounded-full p-3">
                <Phone className="w-6 h-6 text-purple-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900 mb-1">Telefone</p>
                <a href={`tel:${clinicInfo.phone}`} className="text-purple-600 hover:underline">
                  (11) 94932-1508
                </a>
                <br />
                <button onClick={handleWhatsApp} className="text-green-600 hover:underline mt-1">
                  WhatsApp: (11) 94932-1508
                </button>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-purple-100 rounded-full p-3">
                <Mail className="w-6 h-6 text-purple-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900 mb-1">Email</p>
                <a href={`mailto:${clinicInfo.email}`} className="text-purple-600 hover:underline break-all">
                  {clinicInfo.email}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-purple-100 rounded-full p-3">
                <MapPin className="w-6 h-6 text-purple-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900 mb-1">Endereço</p>
                <p className="text-gray-700">{clinicInfo.address}</p>
              </div>
            </div>

            <div className="flex items-start gap-4 p-4 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow">
              <div className="bg-purple-100 rounded-full p-3">
                <Clock className="w-6 h-6 text-purple-600" />
              </div>
              <div>
                <p className="font-semibold text-gray-900 mb-1">Horário de Funcionamento</p>
                <p className="text-gray-700">{clinicInfo.hours}</p>
              </div>
            </div>

            {/* Social Media */}
            <div className="pt-4">
              <p className="font-semibold text-gray-900 mb-4">Siga-nos nas Redes Sociais</p>
              <div className="flex gap-4">
                <a 
                  href={`https://instagram.com/${clinicInfo.instagram.replace('@', '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-gradient-to-br from-purple-600 to-pink-500 text-white p-3 rounded-full hover:scale-110 transition-transform"
                >
                  <Instagram className="w-6 h-6" />
                </a>
                <a 
                  href={`https://facebook.com/${clinicInfo.facebook}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-blue-600 text-white p-3 rounded-full hover:scale-110 transition-transform"
                >
                  <Facebook className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>

          {/* Contact Card */}
          <div>
            <Card className="border-2 border-purple-200 shadow-xl sticky top-24">
              <CardContent className="p-8">
                <div className="text-center mb-6">
                  <div className="bg-purple-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Phone className="w-10 h-10 text-purple-600" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {clinicInfo.name}
                  </h3>
                  <p className="text-purple-600 font-semibold">{clinicInfo.doctorName}</p>
                </div>

                <div className="space-y-4 mb-6">
                  <div className="bg-purple-50 rounded-lg p-4">
                    <p className="text-sm text-gray-600 mb-1">Telefone de Contato</p>
                    <a href={`tel:${clinicInfo.phone}`} className="text-lg font-bold text-purple-600 hover:underline">
                      (11) 94932-1508
                    </a>
                  </div>

                  <div className="bg-purple-50 rounded-lg p-4">
                    <p className="text-sm text-gray-600 mb-1">Email</p>
                    <a href={`mailto:${clinicInfo.email}`} className="text-sm font-semibold text-purple-600 hover:underline break-all">
                      {clinicInfo.email}
                    </a>
                  </div>
                </div>

                <div className="space-y-3">
                  <button
                    onClick={handleWhatsApp}
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-lg transition-colors flex items-center justify-center gap-2"
                  >
                    <Phone className="w-5 h-5" />
                    Falar no WhatsApp
                  </button>
                  
                  <a
                    href={`tel:${clinicInfo.phone}`}
                    className="w-full bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-lg transition-colors flex items-center justify-center gap-2"
                  >
                    <Phone className="w-5 h-5" />
                    Ligar Agora
                  </a>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;